<template>
  <div class="page">
    <navigator-menu :parentMsg="project_id"></navigator-menu>
    <el-card class="download-body">
        <span style="font-weight: bold; font-size: 25px;">Entity Dicts</span>
        <el-divider />
            <el-table
                :data="tableData.slice((currentPage-1)*pageSize,currentPage*pageSize)"
                style="width: 100%;background-color: rgba(255, 255, 255, 0.7);"
                height="25rem"
                stripe="true"
                >
                <el-table-column
                  type="index"
                  width="120"
                  label="#">
                </el-table-column>
                <el-table-column
                prop="word"
                label="Entity Name"
                width="600">
                </el-table-column>
                <el-table-column
                prop="label"
                label="Concept"
                width="200">
                </el-table-column>
                <el-table-column
                fixed="right"
                label="Operation"
                width="120">
                <template #default="scope">
                    <el-button
                    @click="deleteRow(scope.$index, tableData)"
                    type="text"
                    size="small">
                    Delete
                    </el-button>
                </template>
                </el-table-column>
                
            </el-table>
            <div class="block" style="margin-top:15px;">
              <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange" 
              :current-page="currentPage" 
              :page-sizes="[1,5,10,20]" 
              :page-size="pageSize" 
              layout="total, sizes, prev, pager, next, jumper" 
              :total="tableData.length">
              </el-pagination>
            </div>
    </el-card>
  </div>
</template>

<script>
import NavigatorMenu from "./ProNavigation";
// import NavigatorMenuMobile from "../components/NavigatorMenuMobile";
import WOW from "wow.js";
import axios from 'axios';
export default {
  name: "Dictionary",
  components: {
  //   AdvSearch,
  //   NavigatorMenuMobile,
    NavigatorMenu,
  //   Edit,
  //   Swiper
  },
  data(){
    return{
        tableData: [{
          project_id: 1,
          id: 1,
          label: "人名",
          word: "吴凯军",
          user_id: 1
        }
      ], 
      csrfToken:'',
      project_id: this.$route.params.project_id,
      currentPage: 1, // 当前页码
      total: 20, // 总条数
      pageSize: 10 ,// 每页的数据条数
      searchWord: '',
      Search: require("@element-plus/icons/lib/Search"),
      searchStyle: 'font-size:23px; height: 10.5vh; width: 70vw; border-radius: 35px;overflow:hidden;',
    }
  },
  created() {
    console.log(this.$route.params.project_id)
    // 生成csrftoken
    var strcookie = document.cookie;//获取cookie字符串
    var arrcookie = strcookie.split("; ");//分割
    //遍历匹配
    for ( var i = 0; i < arrcookie.length; i++) {
      var arr = arrcookie[i].split("=");
      if (arr[0] == "csrftoken"){
        this.csrfToken = arr[1];
      }
    }
    this.getConcept()
  },
  mounted() {

    // this.suggestions = this.loadAll();
    // var swiper = new Swiper(".swiper-container", {
    //   effect: "coverflow",
    //   grabCursor: true,
    //   centeredSlides: true,
    //   slidesPerView: "auto",
    //   coverflowEffect: {
    //     rotate: 0, //把旋转角度改为0度
    //     stretch: 0,
    //     depth: 100,
    //     modifier: 1,
    //     slideShadows: true,
    //   },
    //   loop: true,
    // });
    const wow = new WOW({
      boxClass: "wow", // animated element css class (default is wow)
      animateClass: "animated", // animation css class (default is animated)
      offset: 0, // distance to the element when triggering the animation (default is 0)
      mobile: true, // trigger animations on mobile devices (default is true)
      live: true, // act on asynchronously loaded content (default is true)
      callback: function (box) {
        // the callback is fired every time an animation is started
        // the argument that is passed in is the DOM node being animated
      },
      scrollContainer: null, // optional scroll container selector, otherwise use window,
      resetAnimation: true, // reset animation on end (default is true)
    });
    console.log(wow)
    wow.init();
    // this.echartinit();
  },
  methods: {
    getDict(){
      axios({
        method: 'get',
        url: '/api/api/projects/'+ this.project_id + '/history/',
        headers:{
          'X-CSRFToken': this.csrfToken,
        },
      }).then(response => {
        // console.log('response:')
        // console.log(response)
        if (response.status == 200) {
          console.log(response.data)
          this.tableData = response.data
          console.log(this.tableData)
          console.log(this.conceptList)
          for (var i = 0;i < this.tableData.length;i++){
            for (var j = 0;j < this.conceptList.length;j++){
              if (this.tableData[i].label == this.conceptList[j].id){
                this.tableData[i].label = this.conceptList[j].text
              }
            }
          }
        } else {
          console.log(response.msg)
          this.$message({
            message: '请检查网络情况',
            type: 'warning'
          })
        }
      })
    },
    getConcept(){
      axios({
          method: 'get',
          url: '/api/api/projects/'+this.project_id+'/labels/',
          headers:{
              'X-CSRFToken': this.csrfToken,
          },
          params: {
              id: this.project_id,
          },
          }).then(response => {
          if(response.status == 200){
              this.conceptList = response.data
              this.getDict()
          }
          }).catch((error) => {
          alert('网络连接失败！')
          })
    },
    deleteRow(index, rows) {
      const deleteOp = window.confirm("确认要Delete该条数据？")
      if (deleteOp){
        axios({
          method: 'delete',
          url: '/api/api/projects/' + this.project_id + '/history/' + rows[index].id,
          headers:{
            'X-CSRFToken': this.csrfToken,
          },
        }).then(response => {
          // console.log('response:')
          // console.log(response)
          if (response.status == 204) {
            rows.splice(index, 1);
          } else {
            console.log(response.msg)
            this.$message({
              message: '请检查网络情况',
              type: 'warning'
            })
          }
        })
      }
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.currentPage = 1;
        this.pageSize = val;
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
        this.currentPage = val;
    }
  }
}
</script>

<style>
.page {
  padding: 0;
  margin: -8px;
  height: 100%;
  width: 100%;
  position:fixed;
  background-image: url("../assets/images/weiminghu.jpeg");
  background-size:cover;
}
.download-body{
  /* margin-left: 300px; */
  left: 350px;
  top: 15vh;
  position: absolute;
  height: 110%;
  width: 75%;
  background-color: rgba(255, 255, 255, 0.7);
  /* border-color: blueviolet;
  background-color: rgba(255, 255, 255, 0.7);; */
}
</style>